export const mibToBytes = (val) => {
  return (parseFloat(val) || 0) * 1.048576 * Math.pow(10, 6);
};

export const kbToBytes = (val) => {
  return (parseFloat(val) || 0) * 1000;
};
